import { connect } from "react-redux";
import React, { useRef, useState } from "react";
import { Button, ModalHeader, ModalBody } from "reactstrap";
import enhancer from "./enhancer/ServiceEnhancer";
import { compose } from "redux";
import { addService, editService } from "services/serviceServices";
import NavigationActions from "redux/navigation/actions";
import { useEffect } from "react";
import Loader from "components/Loader";
import { getAllVenues } from "services/venueServices";
import Select from "react-select";
import PlaceHolderImage from "../../../assets/images/placeholder.png";

const { success, error } = NavigationActions;

const ServiceModal = props => {
  const { isEdit, editData, onClose } = props;
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    setFieldValue,
    isValid,
    setValues,
    handleSubmit,
    setFieldError,
    toggleRefresh
  } = props;

  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [venueData, setVenueData] = useState([]);

  useEffect(() => {
    isEdit && setValues({ ...editData });
  }, [editData]);

  const ServiceHandler = async e => {
    e.preventDefault();
    handleSubmit();
    if (isValid) {
      var formData = new FormData();
      formData.append("file_image", values.file_image);
      formData.append("name", values.name.toLowerCase());
      formData.append("description", values.description);
      formData.append("status", values.status);

      // Handle venue_data as array
      if (values.venue_data && Array.isArray(values.venue_data)) {
        values.venue_data.forEach(venueId => {
          formData.append("venue_data[]", venueId);
        });
      }

      setLoading(true);
      isEdit
        ? await editService(token, values._id, formData).then(res => {
            if (res.success) {
              success(res.message);
              setLoading(false);
              toggleRefresh(true);
              onClose();
            } else {
              error(res.message);
              setLoading(false);
            }
          })
        : await addService(token, formData).then(res => {
            if (res.success) {
              success(res.message);
              setLoading(false);
              toggleRefresh(true);
              onClose();
            } else {
              error(res.message);
              setLoading(false);
            }
            setValues({});
          });
    }
  };

  const handleImageChange = e => {
    if (e.target.files.length !== 1) {
      return;
    }
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    // Check if the selected file type is allowed
    if (!allowedTypes.includes(file.type)) {
      setFieldError(e.target.name, "Only .jpg, .jpeg, .png files are allowed.");
      e.target.value = "";
      return;
    }
    // check if file is less than 2MB
    if (file.size > 2 * 1024 * 1024) {
      setFieldError(e.target.name, "File size should be less than 2MB.");
      e.target.value = "";
      return;
    }

    // Set the selected file in Formik if the file type is valid
    setFieldValue(e.target.name, file);
    fileInputRef.current.value = "";
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  const getVenuesData = async () => {
    await getAllVenues(token)
      .then(res => {
        let venueOptions = res.data.map(venue => {
          return { value: venue._id, label: venue.name };
        });
        setVenueData(venueOptions);
      })
      .catch(err => {
        error(err.message);
      });
  };

  useEffect(() => {
    getVenuesData();
  }, []);

  // Helper function to get selected venue options for react-select
  const getSelectedVenues = () => {
    if (!values.venue_data) return [];

    // If venue_data is already an array of IDs
    if (Array.isArray(values.venue_data)) {
      return venueData.filter(venue => values.venue_data.includes(venue.value));
    }

    // If venue_data is a single ID (for backward compatibility)
    return venueData.filter(venue => venue.value === values.venue_data);
  };

  return (
    <>
      <ModalHeader toggle={() => onClose()}>
        {isEdit ? "Edit" : "Add"} Service
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group">
            <label>
              Name <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="name"
              onChange={handleChange}
              value={values.name}
              onBlur={handleBlur}
              placeholder="Service Name"
            />
            <Error field="name" />
          </div>
          <div className="form-group">
            <label>
              Venue <span className="red">*</span>
            </label>
            <Select
              value={getSelectedVenues()}
              name="venue_data"
              options={venueData}
              isMulti={true}
              isClearable={true}
              className="basic-multi-select w-100"
              classNamePrefix="select"
              onChange={selected => {
                if (selected && selected.length > 0) {
                  // Extract array of venue IDs from selected options
                  const venueIds = selected.map(option => option.value);
                  console.log("selected venues", venueIds);
                  setFieldValue("venue_data", venueIds);
                } else {
                  // Set to empty array when cleared
                  setFieldValue("venue_data", []);
                }
              }}
            />
            <Error field="venue_data" />
          </div>
          <div className="form-group">
            <label>Image</label>
            <br />

            <input
              ref={fileInputRef}
              type="file"
              id="file_image"
              name="file_image"
              className="form-control react-form-input"
              accept="image/*"
              onChange={handleImageChange}
              onBlur={handleBlur}
            />
            <Error field="file_image" />
            {values?.file_image && (
              <>
                <br />
                <img
                  src={
                    values?.file_image instanceof Blob
                      ? URL.createObjectURL(values?.file_image)
                      : `${process.env.REACT_APP_UPLOAD_DIR}${values?.file_image}`
                  }
                  className="profile-img"
                  alt="no"
                  width={100}
                  onError={e => {
                    e.target.src = PlaceHolderImage;
                  }}
                />
                <br />
              </>
            )}
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              type="text"
              className="form-control react-form-input"
              id="description"
              onChange={handleChange}
              value={values.description}
              onBlur={handleBlur}
              placeholder="Service description"
            />
            <Error field="description" />
          </div>
          <div className="form-group">
            <label>
              Status <span className="red">*</span>
            </label>
            <select
              className="detail-input-select custom-select"
              value={values?.status}
              name="status"
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <option value={true}>Active</option>
              <option value={false}>Deactive</option>
            </select>
            <Error field="status" />
          </div>
          <div className="row">
            <div className="col-5 offset-2 offset-sm-4 col-sm-4">
              <Button
                onClick={e => ServiceHandler(e)}
                type="submit"
                className="btn form-button modaladdbutton"
                disabled={isValid ? false : true}
              >
                {isEdit ? "Update" : "Add"}
              </Button>
            </div>
            <div className="col-5 col-sm-4">
              <Button
                onClick={() => {
                  onClose();
                }}
                className="btn form-button modalcancelbutton"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </ModalBody>
      {loading ? <Loader /> : ""}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  enhancer,
  connect(mapStateToProps, { success, error })
)(ServiceModal);
